<template>
    <div v-if="branch">
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Profile</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <input v-model="branch.settings.bk.profileName" type="text" class="input oc-input" />
                    </p>
                </div>
            </div>
        </div>
        <div class="field is-horizontal">
            <div class="field-label">
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <button class="button is-success" @click="saveAsync();">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import branchService from "../../../../../../services/branch.service";

    export default {
        name: "settings",
        data: () => ({
            client: null,
            branch: null,
            bkSettings: null
        }),
        computed: {
            clientId: function() {
                return Number(this.$route.params.clientId);
            },
            branchName: function() {
                return this.$route.params.branch;
            }
        },
        mounted() {
            this.loadBranchAsync();
        },
        methods: {
            async loadBranchAsync() {
                this.branch = await branchService.get(this.clientId, this.branchName);
            },
            async saveAsync() {
                await branchService.saveSettings(this.clientId, this.branch.branch, this.branch.settings);
                this.branch = await branchService.update(this.branch);
            }
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/bk/settings.vue